<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Role Assignment</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card">
        <div class="card-body mt-3 mb-3">
          <div class="row" style="margin-left: 15px; margin-right: 15px">
            <div class="col-12 col-lg-5">
              <v-select
                v-model="employee"
                :options="listEmployee"
                :reduce="(e) => e"
                label="fullname"
                placeholder="Search Employee Name or iSafe number"
                @search="debouncedSearch"
                @input="getEmployees()">
                <span slot="no-options"
                  >Search employee name or iSafe number</span
                >
                <!-- <template slot="option" slot-scope="option">
                  {{ option.attributes }}
                </template> -->
              </v-select>
            </div>
            <div class="col">
              <div class="form-group d-flex float-end">
                <b-button v-b-modal.modal-2 variant="primary">
                  <span class="fe fe-plus-circle"></span>
                  Add Users
                </b-button>
              </div>
            </div>
          </div>
          <!-- <div class="card-header"> -->
          <div class="col-lg-12 mt-5" v-if="hasSelectedEmployee">
            <div class="row">
              <div class="col-lg-2">
                <p class="small">
                  <strong>Username</strong>
                </p>
              </div>
              <div class="col">
                <p class="small">{{ username }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <p class="small">
                  <strong>Name</strong>
                </p>
              </div>
              <div class="col">
                <p class="small">{{ firstName }} {{ lastName }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <p class="small">
                  <strong>Departement</strong>
                </p>
              </div>
              <div class="col">
                <p class="small" v-if="departement != 'null'">
                  {{ departement }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <p class="small">
                  <strong>Position</strong>
                </p>
              </div>
              <div class="col">
                <p class="small" v-if="position != 'null'">
                  {{ position }}
                </p>
              </div>
            </div>
          </div>
          <div class="card-header" v-if="hasSelectedEmployee">
            <h3></h3>
            <b-button v-b-modal.modal-1 variant="primary" @click="isAdd = true">
              <span class="fe fe-plus-circle"></span>
              Add
            </b-button>
          </div>
          <div v-if="hasSelectedEmployee">
            <div v-if="isLoadingRoles" class="text-center py-5">
              <b-spinner variant="primary" label="Loading roles..."></b-spinner>
            </div>
            <vue-good-table
              v-else
              :line-numbers="true"
              :columns="column"
              :rows="listEmployeeById"
              :sort-options="{
                enabled: false
              }"
              :total-rows="10"
              :pagination-options="{
                enabled: false,
                mode: 'pages',
                position: 'bottom',
                perPage: 10,
                perPageDropdown: [10, 50, 100],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Rows per page',
                ofLabel: 'of',
                pageLabel: 'page',
                allLabel: 'All'
              }"
              style-class="vgt-table border-0 table">
              <!-- Loading -->
              <div slot="emptystate" class="text-center font-size-14">
                No data available
              </div>
              <!-- Custom Rows -->
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'action'">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="confirmDeleteRole(props.row)"
                    :disabled="deletingRoleId === (props.row.role_id || props.row.roleId)">
                    <span
                      v-if="deletingRoleId === (props.row.role_id || props.row.roleId)"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"></span>
                    <span v-else class="fe fe-trash"></span>
                    <span class="ml-1">Delete</span>
                  </b-button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-1" size="lg" hide-footer title="Add Role">
      <form @submit.prevent="saveAdd()">
        <div class="form-group col">
          <label>Application <span class="text-danger">*</span></label>
          <v-select
            v-model="app"
            :options="listApp.data"
            v-validate="'required'"
            label="name"
            :reduce="(e) => e"
            name="Application"
            @input="getRoles()" />
          <span
            class="text-sm text-danger"
            v-show="errors.has('Application')"
            >{{ errors.first("Application") }}</span
          >
        </div>
        <div class="form-group col" v-if="app != ''">
          <label>Role <span class="text-danger">*</span></label>
          <v-select
            v-model="role"
            :options="listRoles"
            v-validate="'required'"
            label="name"
            :reduce="(e) => e"
            name="Role" />
          <span class="text-sm text-danger" v-show="errors.has('Role')">{{
            errors.first("Role")
          }}</span>
        </div>
        <div class="form-group">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false">
            Save
          </button>
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
            v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
            Loading...
          </button>
          <button
            type="button"
            style="margin-right: auto; float: right"
            class="mt-4 btn btn-outline-primary mr-3"
            @click="$bvModal.hide('modal-1')">
            Cancel
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal id="modal-2" size="xl" hide-footer title="Add Users">
      <template v-slot:modal-header-close>
        <i class="fe fe-x" @click="closeModal2()"></i>
      </template>
      <form @submit.prevent="saveAddUser()">
        <div class="row g-3">
          <div class="form-group col">
            <label>Fullname <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="bodyAdd.fullname"
              class="form-control"
              placeholder="Fullname"
              v-validate="'required'"
              name="Fullname" />
            <span class="text-sm text-danger" v-show="errors.has('Fullname')">{{
              errors.first("Fullname")
            }}</span>
          </div>
          <div class="form-group col">
            <label>Email <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="bodyAdd.email"
              class="form-control"
              placeholder="Email"
              v-validate="'required|email'"
              name="Email" />
            <span class="text-sm text-danger" v-show="errors.has('Email')">{{
              errors.first("Email")
            }}</span>
          </div>
        </div>
        <div class="row g-3">
          <div class=""></div>
          <div class="">
            <div class="form-group d-flex float-end">
              <b-button v-b-modal.modal-3 variant="primary">
                <span class="fe fe-plus-circle"></span>
                Add Form
              </b-button>
            </div>
          </div>
        </div>
        <div class="row g-3">
          <div
            class="col-6"
            v-for="(item, index) in usersAttribute"
            :key="index">
            <div class="form-group" v-if="item == 'address'">
              <label>Address</label>
              <input
                type="text"
                v-model="bodyAdd.address"
                class="form-control"
                placeholder="Address" />
            </div>
            <div class="form-group" v-if="item == 'birth_date'">
              <label>Birth Date</label>
              <input
                type="date"
                v-model="bodyAdd.birth_date"
                class="form-control"
                placeholder="Birth Date" />
            </div>
            <div class="form-group" v-if="item == 'bus_head_name'">
              <label>Bus Head Name</label>
              <input
                type="text"
                v-model="bodyAdd.bus_head_name"
                class="form-control"
                placeholder="Bus Head Name" />
            </div>
            <div class="form-group" v-if="item == 'bus_head_nik'">
              <label>Bus Head Nik</label>
              <input
                type="number"
                v-model="bodyAdd.bus_head_nik"
                class="form-control"
                placeholder="Bus Head Nik" />
            </div>
            <div class="form-group" v-if="item == 'bus_head_position_id'">
              <label>Bus Head Position Id</label>
              <input
                type="number"
                v-model="bodyAdd.bus_head_position_id"
                class="form-control"
                placeholder="Bus Head Position Id" />
            </div>
            <div class="form-group" v-if="item == 'bus_head_position_name'">
              <label>Bus Head Position Name</label>
              <input
                type="text"
                v-model="bodyAdd.bus_head_position_name"
                class="form-control"
                placeholder="Bus Head Position Name" />
            </div>
            <div class="form-group" v-if="item == 'ceo_name'">
              <label>Ceo Name</label>
              <input
                type="text"
                v-model="bodyAdd.ceo_name"
                class="form-control"
                placeholder="Ceo Name" />
            </div>
            <div class="form-group" v-if="item == 'ceo_nik'">
              <label>Ceo Nik</label>
              <input
                type="number"
                v-model="bodyAdd.ceo_nik"
                class="form-control"
                placeholder="Ceo Nik" />
            </div>
            <div class="form-group" v-if="item == 'ceo_position_id'">
              <label>Ceo Position Id</label>
              <input
                type="number"
                v-model="bodyAdd.ceo_position_id"
                class="form-control"
                placeholder="Ceo Position Id" />
            </div>
            <div class="form-group" v-if="item == 'ceo_position_name'">
              <label>Ceo Position Name</label>
              <input
                type="text"
                v-model="bodyAdd.ceo_position_name"
                class="form-control"
                placeholder="Ceo Position Name" />
            </div>
            <div class="form-group" v-if="item == 'company_code'">
              <label>Company Code</label>
              <input
                type="number"
                v-model="bodyAdd.company_code"
                class="form-control"
                placeholder="Company Code" />
            </div>
            <div class="form-group" v-if="item == 'company_name'">
              <label>Company Name</label>
              <input
                type="text"
                v-model="bodyAdd.company_name"
                class="form-control"
                placeholder="Company Name" />
            </div>
            <div class="form-group" v-if="item == 'cost_center'">
              <label>Cost Center</label>
              <input
                type="date"
                v-model="bodyAdd.cost_center"
                class="form-control"
                placeholder="Cost Center" />
            </div>
            <div class="form-group" v-if="item == 'department'">
              <label>Department</label>
              <input
                type="text"
                v-model="bodyAdd.department"
                class="form-control"
                placeholder="Department" />
            </div>
            <div class="form-group" v-if="item == 'dept_head_name'">
              <label>Dept Head Name</label>
              <input
                type="text"
                v-model="bodyAdd.dept_head_name"
                class="form-control"
                placeholder="Dept Head Name" />
            </div>
            <div class="form-group" v-if="item == 'dept_head_nik'">
              <label>Dept Head Nik</label>
              <input
                type="number"
                v-model="bodyAdd.dept_head_nik"
                class="form-control"
                placeholder="Dept Head Nik" />
            </div>
            <div class="form-group" v-if="item == 'dept_head_position_id'">
              <label>Dept Head Position Id</label>
              <input
                type="number"
                v-model="bodyAdd.dept_head_position_id"
                class="form-control"
                placeholder="Dept Head Position Id" />
            </div>
            <div class="form-group" v-if="item == 'dept_head_position_name'">
              <label>Dept Head Position Name</label>
              <input
                type="text"
                v-model="bodyAdd.dept_head_position_name"
                class="form-control"
                placeholder="Dept Head Position Name" />
            </div>
            <div class="form-group" v-if="item == 'direct_superior_name'">
              <label>Direct Superior Name</label>
              <input
                type="text"
                v-model="bodyAdd.direct_superior_name"
                class="form-control"
                placeholder="Direct Superior Name" />
            </div>
            <div class="form-group" v-if="item == 'direct_superior_nik'">
              <label>Direct Superior NIK</label>
              <input
                type="text"
                v-model="bodyAdd.direct_superior_nik"
                class="form-control"
                placeholder="Direct Superior NIK" />
            </div>
            <div
              class="form-group"
              v-if="item == 'direct_superior_position_id'">
              <label>Direct Superior Position Id</label>
              <input
                type="text"
                v-model="bodyAdd.direct_superior_position_id"
                class="form-control"
                placeholder="Direct Superior Position Id" />
            </div>
            <div
              class="form-group"
              v-if="item == 'direct_superior_position_name'">
              <label>Direct Superior Position Name</label>
              <input
                type="text"
                v-model="bodyAdd.direct_superior_position_name"
                class="form-control"
                placeholder="Direct Superior Position Name" />
            </div>
            <div class="form-group" v-if="item == 'director_name'">
              <label>Director Name</label>
              <input
                type="text"
                v-model="bodyAdd.director_name"
                class="form-control"
                placeholder="Director Name" />
            </div>
            <div class="form-group" v-if="item == 'director_nik'">
              <label>Director NIK</label>
              <input
                type="number"
                v-model="bodyAdd.director_nik"
                class="form-control"
                placeholder="Director NIK" />
            </div>
            <div class="form-group" v-if="item == 'director_position_id'">
              <label>Director Position Id</label>
              <input
                type="number"
                v-model="bodyAdd.director_position_id"
                class="form-control"
                placeholder="Director Position Id" />
            </div>
            <div class="form-group" v-if="item == 'director_position_name'">
              <label>Director Position Name</label>
              <input
                type="text"
                v-model="bodyAdd.director_position_name"
                class="form-control"
                placeholder="Director Position Name" />
            </div>
            <div class="form-group" v-if="item == 'direktorat'">
              <label>Direktorat</label>
              <input
                type="text"
                v-model="bodyAdd.direktorat"
                class="form-control"
                placeholder="Direktorat" />
            </div>
            <div class="form-group" v-if="item == 'div_head_name'">
              <label>Div Head Name</label>
              <input
                type="text"
                v-model="bodyAdd.div_head_name"
                class="form-control"
                placeholder="Div Head Name" />
            </div>
            <div class="form-group" v-if="item == 'div_head_nik'">
              <label>Div Head NIK</label>
              <input
                type="number"
                v-model="bodyAdd.div_head_nik"
                class="form-control"
                placeholder="Div Head NIK" />
            </div>
            <div class="form-group" v-if="item == 'div_head_position_id'">
              <label>Div Head Position Id</label>
              <input
                type="number"
                v-model="bodyAdd.div_head_position_id"
                class="form-control"
                placeholder="Div Head Position Id" />
            </div>
            <div class="form-group" v-if="item == 'div_head_position_name'">
              <label>Div Head Position Name</label>
              <input
                type="text"
                v-model="bodyAdd.div_head_position_name"
                class="form-control"
                placeholder="Div Head Position Name" />
            </div>
            <div class="form-group" v-if="item == 'divisi'">
              <label>Divisi</label>
              <input
                type="text"
                v-model="bodyAdd.divisi"
                class="form-control"
                placeholder="Divisi" />
            </div>
            <div class="form-group" v-if="item == 'emergency_contact'">
              <label>Emergency Contact</label>
              <input
                type="text"
                v-model="bodyAdd.emergency_contact"
                class="form-control"
                placeholder="Emergency Contact" />
            </div>
            <div class="form-group" v-if="item == 'end_date'">
              <label>End Date</label>
              <input
                type="date"
                v-model="bodyAdd.end_date"
                class="form-control"
                placeholder="End Date" />
            </div>
            <div class="form-group" v-if="item == 'gender'">
              <label>Gender</label>
              <input
              type="text"
                v-model="bodyAdd.gender"
                class="form-control"
                placeholder="Gender" />
            </div>
            <div class="form-group" v-if="item == 'gender_desc'">
              <label>Gender Desc</label>
              <input
              type="text"
                v-model="bodyAdd.gender_desc"
                class="form-control"
                placeholder="Gender Desc" />
            </div>
            <div class="form-group" v-if="item == 'is_chief'">
              <label>Is Chief</label>
              <input
              type="text"
                v-model="bodyAdd.is_chief"
                class="form-control"
                placeholder="Is Chief" />
            </div>
            <div class="form-group" v-if="item == 'mattermostid'">
              <label>Mattermostid</label>
              <input
                type="number"
                v-model="bodyAdd.mattermostid"
                class="form-control"
                placeholder="Mattermostid" />
            </div>
            <div class="form-group" v-if="item == 'nik'">
              <label>NIK</label>
              <input
                type="number"
                v-model="bodyAdd.nik"
                class="form-control"
                placeholder="NIK" />
            </div>
            <div class="form-group" v-if="item == 'organizational_unit'">
              <label>Organizational Unit</label>
              <input
                type="number"
                v-model="bodyAdd.organizational_unit"
                class="form-control"
                placeholder="Organizational Unit" />
            </div>
            <div class="form-group" v-if="item == 'organizational_unit_name'">
              <label>Organizational Unit Name</label>
              <input
                type="text"
                v-model="bodyAdd.organizational_unit_name"
                class="form-control"
                placeholder="Organizational Unit Name" />
            </div>
            <div class="form-group" v-if="item == 'parent_org_unit'">
              <label>Parent Org Unit</label>
              <input
                type="number"
                v-model="bodyAdd.parent_org_unit"
                class="form-control"
                placeholder="Parent Org Unit" />
            </div>
            <div class="form-group" v-if="item == 'parent_org_unit_desc'">
              <label>Parent Org Unit Desc</label>
              <input
                type="text"
                v-model="bodyAdd.parent_org_unit_desc"
                class="form-control"
                placeholder="Parent Org Unit Desc" />
            </div>
            <div class="form-group" v-if="item == 'personnel_area'">
              <label>Personnel Area</label>
              <input
                type="text"
                v-model="bodyAdd.personnel_area"
                class="form-control"
                placeholder="Personnel Area" />
            </div>
            <div class="form-group" v-if="item == 'personnel_area_text'">
              <label>Personnel Area Text</label>
              <input
                type="text"
                v-model="bodyAdd.personnel_area_text"
                class="form-control"
                placeholder="Personnel Area Text" />
            </div>
            <div class="form-group" v-if="item == 'personnel_subarea'">
              <label>Personnel Subarea</label>
              <input
                type="text"
                v-model="bodyAdd.personnel_subarea"
                class="form-control"
                placeholder="Personnel Subarea" />
            </div>
            <div class="form-group" v-if="item == 'personnel_subarea_text'">
              <label>Personnel Subarea Text</label>
              <input
                type="text"
                v-model="bodyAdd.personnel_subarea_text"
                class="form-control"
                placeholder="Personnel Subarea Text" />
            </div>
            <div class="form-group" v-if="item == 'phone_no'">
              <label>Phone No</label>
              <input
                type="number"
                v-model="bodyAdd.phone_no"
                class="form-control"
                placeholder="Phone No" />
            </div>
            <div class="form-group" v-if="item == 'position_id'">
              <label>Position Id</label>
              <input
                type="number"
                v-model="bodyAdd.position_id"
                class="form-control"
                placeholder="Position Id" />
            </div>
            <div class="form-group" v-if="item == 'position_title'">
              <label>Position Title</label>
              <input
                type="text"
                v-model="bodyAdd.position_title"
                class="form-control"
                placeholder="Position Title" />
            </div>
            <div class="form-group" v-if="item == 'sapUser'">
              <label>SAP User</label>
              <input
                v-model="bodyAdd.sapUser"
                class="form-control"
                placeholder="SAP User" />
            </div>
            <div class="form-group" v-if="item == 'section'">
              <label>Section</label>
              <input
                type="text"
                v-model="bodyAdd.section"
                class="form-control"
                placeholder="Section" />
            </div>
            <div class="form-group" v-if="item == 'start_date'">
              <label>Start Date</label>
              <input
                type="date"
                v-model="bodyAdd.start_date"
                class="form-control"
                placeholder="Start Date"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false">
            Save
          </button>
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
            v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
            Loading...
          </button>
          <button
            type="button"
            style="margin-right: auto; float: right"
            class="mt-4 btn btn-outline-primary mr-3"
            @click="$bvModal.hide('modal-2')">
            Cancel
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal id="modal-3" size="lg" hide-footer title="Add Form">
      <form @submit.prevent="saveAddForm()">
        <div class="form-group col">
          <label>Select Form Type <span class="text-danger">*</span></label>
          <v-select
            v-model="selectFormType"
            :options="listUserAtributr"
            :reduce="(e) => e"
            v-validate="'required'"
            name="Select Form Type" />
          <span
            class="text-sm text-danger"
            v-show="errors.has('Select Form Type')"
            >{{ errors.first("Select Form Type") }}</span
          >
        </div>
        <div class="form-group">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false">
            Save
          </button>
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
            v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
            Loading...
          </button>
          <button
            type="button"
            style="margin-right: auto; float: right"
            class="mt-4 btn btn-outline-primary mr-3"
            @click="$bvModal.hide('modal-3')">
            Cancel
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "RoleTemplate",
  computed: {
    listEmployee() {
      return this.$store.getters["role_assigment/listEmployee"];
    },
    listApp() {
      return this.$store.getters["role_template/listApp"];
    },
    listRoles() {
      return this.$store.getters["role_template/listRoles"];
    },
    listEmployeeById() {
      return this.$store.getters["role_assigment/EmployeeById"];
    },
    listUserAtributr() {
      return this.$store.getters["users/listUsers"];
    },
    hasSelectedEmployee() {
      return !!(this.employee && this.employee.id);
    }
  },
  data() {
    return {
      searchTimeout: null,
      username: "",
      firstName: "",
      lastName: "",
      fullname: "",
      departement: "",
      position: "",
      employee: "",
      app: "",
      role: "",
      isAdd: true,
      isRole: false,
      loadRole: false,
      isLoading: false,
      isLoadingRoles: false,
      deletingRoleId: "",
      assignBy: "",
      selectFormType: "",
      usersAttribute: [],
      listGenderDesc: ["Male", "Female"],
      isChief: ["Y", "N"],
      optionsapUser: ["true", "false"],
      listGender: [
        {
          id: 0,
          name: "Female",
        },
        {
          id: 1,
          name: "Male",
        },
      ],
      bodyAdd: {
        fullname: "",
        email: "",
        address: "",
        birth_date: "",
        bus_head_name: "",
        bus_head_nik: "",
        bus_head_position_id: "",
        bus_head_position_name: "",
        ceo_name: "",
        ceo_nik: "",
        ceo_position_id: "",
        ceo_position_name: "",
        company_code: "",
        company_name: "",
        cost_center: "",
        department: "",
        dept_head_name: "",
        dept_head_nik: "",
        dept_head_position_id: "",
        dept_head_position_name: "",
        direct_superior_name: "",
        direct_superior_nik: "",
        direct_superior_position_id: "",
        direct_superior_position_name: "",
        director_name: "",
        director_nik: "",
        director_position_id: "",
        director_position_name: "",
        direktorat: "",
        div_head_name: "",
        div_head_nik: "",
        div_head_position_id: "",
        div_head_position_name: "",
        divisi: "",
        emergency_contact: "",
        end_date: "",
        gender: "",
        gender_desc: "",
        is_chief: "",
        mattermostid: "",
        nik: "",
        organizational_unit: "",
        organizational_unit_name: "",
        parent_org_unit: "",
        parent_org_unit_desc: "",
        personnel_area: "",
        personnel_area_text: "",
        personnel_subarea: "",
        personnel_subarea_text: "",
        phone_no: "",
        position_id: "",
        position_title: "",
        sapUser: "",
        section: "",
        start_date: ""
      },
      column: [
        {
          label: "Application",
          field: "app_name",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Role",
          field: "role_name",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Assign By",
          field: "assignBy",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Action",
          field: "action",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        }
      ]
    };
  },

  mounted() {
    this.assignBy = localStorage.getItem("fullname");
    this.getApp();
    this.getUsersAttribute();
  },
  methods: {
    debouncedSearch(searchTerm) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      this.searchTimeout = setTimeout(() => {
        this.getEmployee(searchTerm);
      }, 1000); 
    },
    async getEmployee(event) {
      try {
        
        if (!event || event.length < 2) {
          return;
        }
        
        let data = {
          search: event
        };
        
        
        await this.$store.dispatch("role_assigment/GET_LIST_EMPLOYEE", data);
        
      } catch (error) {
        console.log("asdsa",error)
        this.$swal({
          icon: 'warning',
          title: 'Search Failed',
          text: error.response.data.error || 'Unable to search employee data',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33'
        })
      }
    },

    closeModal2() {
      this.$bvModal.hide("modal-2");
      this.bodyAdd = {
        fullname: "",
        email: "",
        address: "",
        birth_date: "",
        bus_head_name: "",
        bus_head_nik: "",
        bus_head_position_id: "",
        bus_head_position_name: "",
        ceo_name: "",
        ceo_nik: "",
        ceo_position_id: "",
        ceo_position_name: "",
        company_code: "",
        company_name: "",
        cost_center: "",
        department: "",
        dept_head_name: "",
        dept_head_nik: "",
        dept_head_position_id: "",
        dept_head_position_name: "",
        direct_superior_name: "",
        direct_superior_nik: "",
        direct_superior_position_id: "",
        direct_superior_position_name: "",
        director_name: "",
        director_nik: "",
        director_position_id: "",
        director_position_name: "",
        direktorat: "",
        div_head_name: "",
        div_head_nik: "",
        div_head_position_id: "",
        div_head_position_name: "",
        divisi: "",
        emergency_contact: "",
        end_date: "",
        gender: "",
        gender_desc: "",
        is_chief: "",
        mattermostid: "",
        nik: "",
        organizational_unit: "",
        organizational_unit_name: "",
        parent_org_unit: "",
        parent_org_unit_desc: "",
        personnel_area: "",
        personnel_area_text: "",
        personnel_subarea: "",
        personnel_subarea_text: "",
        phone_no: "",
        position_id: "",
        position_title: "",
        sapUser: "",
        section: "",
        start_date: "",
      };
      this.usersAttribute = [];
    },

    getEmployees() {
      try {
        if (!this.employee || !this.employee.id) {
          this.resetSelectedEmployee();
          return;
        }

        this.username = this.employee.username || "-";
        this.firstName = this.employee.firstName || "-";
        this.lastName = this.employee.lastName || "-";
        this.fullname = this.employee.fullname || "-";
        
        if (this.employee.attributes) {
          this.departement = this.employee.attributes.department?.[0] || "-";
          this.position =
            this.employee.attributes.position?.[0] ||
            this.employee.attributes.position_title?.[0] ||
            "-";
        } else {
          console.log("attributes do not exist");
          this.departement = "-";
          this.position = "-";
        }

        this.getEmployeeById();

      } catch (error) {
        console.log("Error",error)
        // this.$swal({
        //   icon: 'error',
        //   title: 'Processing Error',
        //   text: 'Unable to process employee data',
        //   confirmButtonColor: '#d33'
        // })
      }
    },

    resetSelectedEmployee() {
      this.username = "";
      this.firstName = "";
      this.lastName = "";
      this.fullname = "";
      this.departement = "";
      this.position = "";
      this.app = "";
      this.role = "";
      this.employee = null;
      this.deletingRoleId = "";
      this.isLoadingRoles = false;
      this.$store.commit("role_assigment/SET_EMPLOYEE_BY_ID", []);
    },

    async getEmployeeById() {
      if (!this.employee || !this.employee.id) {
        return;
      }

      let data = {
        id: this.employee.id,
        email: this.employee.email
      };

      this.isLoadingRoles = true;
      this.$store.commit("role_assigment/SET_EMPLOYEE_BY_ID", []);
      try {
        await this.$store.dispatch("role_assigment/GET_EMPLOYEE_BY_ID", data);
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to load user roles.";
        this.$swal.fire({
          icon: "error",
          title: "Load failed",
          text: message
        });
      } finally {
        this.isLoadingRoles = false;
      }
    },

    getApp() {
      this.$store.dispatch("role_template/GET_LIST_APP");
    },

    getUsersAttribute() {
      this.$store.dispatch("users/GET_LIST_USERS");
    },

    getRoles() {
      this.role_id = "";
      let data = {
        app_id: this.app.id,
        fullname: this.employee.fullname,
        nik: this.employee.nik,
        email: this.employee.email,
        source: this.employee.source
      };
      this.$store.dispatch("role_template/GET_LIST_ROLES", data);
    },

    saveAddForm() {
      this.usersAttribute.push(this.selectFormType);
      this.$bvModal.hide("modal-3");
      this.selectFormType = "";
    },

    saveAdd() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              }
            })
            .fire({
              icon: "error",
              title: "Please fill out the mandatory fields"
            });
        } else {
          let data = {
            user_id: this.employee.id,
            fullname: this.employee.fullname,
            email: this.employee.email,
            source: this.employee.source,
            nik: this.employee.nik,
            app_id: this.app.id,
            app_name: this.app.name,
            role_id: this.role.id,
            role_name: this.role.name,
            isGranted: true,
            assignBy: this.assignBy
          };
          this.isLoading = true;
          try {
            this.$store
              .dispatch("role_assigment/CREATE_DATA", data)
              .then((resp) => {
                this.$swal(
                  "Saved",
                  "Your checked has been saved",
                  "success"
                ).then(() => {
                  this.app = "";
                  this.role = "";
                  this.isLoading = false;
                  this.$bvModal.hide("modal-1");
                  this.getEmployees();
                });
              })
              .catch((err) => {
                this.isLoading = false;
                this.$swal.fire({
                  icon: "error",
                  title: "Error when adding role"
                });
              });
          } catch (error) {
            this.$swal("Error", "Error while add data", "error");
          }
        }
      });
    },

    async confirmDeleteRole(role) {
      if (!role) {
        return;
      }

      const roleId = role.role_id || role.roleId;
      const roleName = role.role_name || role.roleName || "this role";
      const selectedFullname =
        (this.employee && this.employee.fullname) || this.fullname || "this user";

      const confirmation = await this.$swal.fire({
        title: "Delete role?",
        text: `Are you sure you want to remove ${roleName} from ${selectedFullname}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d33"
      });

      if (!confirmation.isConfirmed) {
        return;
      }

      const clientId = role.client_key 
      const email =
        role.email ||
        role.user_email ||
        role.userEmail ||
        (this.employee && this.employee.email) ||
        "";

      if (!clientId || !roleId || !email) {
        this.$swal.fire({
          icon: "error",
          title: "Missing data",
          text: "Unable to delete role because required data is incomplete."
        });
        return;
      }

      const payload = {
        role_id: roleId,
        role_name: role.role_name || role.roleName || roleName,
        email
      };

      this.deletingRoleId = roleId;
      try {
        await this.$store.dispatch("role_assigment/DELETE_ROLE_USER", {
          clientId,
          payload
        });

        this.$swal.fire("Deleted", "Role has been removed from the user.", "success");
        this.getEmployeeById();
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to delete the user role.";
        this.$swal.fire({
          icon: "error",
          title: "Delete failed",
          text: message
        });
      } finally {
        this.deletingRoleId = "";
      }
    },

    saveAddUser() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        // return console.log(this.bodyAdd);
        this.isLoading = true;
        try {
          this.$store
            .dispatch("users/CREATE_DATA", this.bodyAdd)
            .then((resp) => {
              this.$swal("Saved", "Saved data success", "success").then(() => {
                this.bodyAdd = {
                  fullname: "",
                  email: "",
                  address: "",
                  birth_date: "",
                  bus_head_name: "",
                  bus_head_nik: "",
                  bus_head_position_id: "",
                  bus_head_position_name: "",
                  ceo_name: "",
                  ceo_nik: "",
                  ceo_position_id: "",
                  ceo_position_name: "",
                  company_code: "",
                  company_name: "",
                  cost_center: "",
                  department: "",
                  dept_head_name: "",
                  dept_head_nik: "",
                  dept_head_position_id: "",
                  dept_head_position_name: "",
                  direct_superior_name: "",
                  direct_superior_nik: "",
                  direct_superior_position_id: "",
                  direct_superior_position_name: "",
                  director_name: "",
                  director_nik: "",
                  director_position_id: "",
                  director_position_name: "",
                  direktorat: "",
                  div_head_name: "",
                  div_head_nik: "",
                  div_head_position_id: "",
                  div_head_position_name: "",
                  divisi: "",
                  emergency_contact: "",
                  end_date: "",
                  gender: "",
                  gender_desc: "",
                  is_chief: "",
                  mattermostid: "",
                  nik: "",
                  organizational_unit: "",
                  organizational_unit_name: "",
                  parent_org_unit: "",
                  parent_org_unit_desc: "",
                  personnel_area: "",
                  personnel_area_text: "",
                  personnel_subarea: "",
                  personnel_subarea_text: "",
                  phone_no: "",
                  position_id: "",
                  position_title: "",
                  sapUser: "",
                  section: "",
                  start_date: ""
                };
                this.isLoading = false;
                this.$bvModal.hide("modal-2");
              });
            });
        } catch (error) {
          this.$swal("Error", "Error while add data", "error");
        }
      });
    }
  }
};
</script>
